const WEIGHT = {
  bolder: 500,
  bold: 500,
  semibold: 500,
  medium: 500,
  normal: 400,
  light: 400,
  lighter: 400,
  thin: 400,
};

export const getWeight = theme => {
  const temp = theme;

  temp.FONT.WEIGHTS = WEIGHT;

  return theme;
};
